module.exports = __webpack_public_path__ + "static/media/flipkart.1fb974ce.png";